<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="The Big Book of Gross Stuff">
<div class="verso">
<p class="versotitle">The Big Book of Gross Stuff</p>
<p>Digital Edition v1.0</p>
<p>Text © 2010 Bart King</p>
<p>Illustrations © 2010 Russell Miller</p>
<p>All rights reserved. No part of this book may be reproduced by any means
                    whatsoever without written permission from the publisher, except brief portions
                    quoted for purpose of review.</p>
<p class="nobreak">Gibbs Smith, Publisher</p>
<p class="nobreak">PO Box 667</p>
<p>Layton, UT 84041</p>
<p class="nobreak">Orders: 1.800.835.4993</p>
<p>www.gibbs-smith.com</p>
<p>Library of Congress Catalog-in-Publishing Data</p>
<p class="nobreak">ISBN-13:978-1-4236-0746-5</p>
<p class="nobreak">ISBN-10: 1-4236-0746-5</p>
<p class="nobreak">1. Curiosities and wonders—Humor. 2. Human
                    body—Miscellanea—Humor. 3. Hygiene—Humor. 4. Conduct of life—Miscellanea—Humor.
                    I. Miller, Russell. II. Title.</p>
<p class="nobreak">PN6231.C85K56 2010</p>
<p class="nobreak">818’.607—dc22</p>
<p class="nobreak">2009035220</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// verso.vue?0675ee5e